<template>
  <div class="serviceDetails">
    <router-link to="/serviceArchieve" class="detailsClsoeBtn">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.75 19.5 8.25 12l7.5-7.5"
        />
      </svg>
    </router-link>
    <div class="detialsMapWrapper">
      <NeshanMap
        :default-type="isDarkMode == true ? 'standard-night' : 'neshan'"
        ref="myMap"
        :key="reloadKey"
        :mapKey="this?.c_set?.map_info?.map_key"
        :serviceKey="this.service_api"
        :zoom="14"
        :poi="true"
        :traffic="true"
        :hide-search-container="true"
        :center="{ latitude: 36.311559, longitude: 59.5870851 }"
        @on-init="getmounted"
        :reverse-on-click="false"
        hide-layers
        class="detialsMap"
      />
    </div>
    <div class="detailsContent">
      <div class="contentWrapper">
        <div class="detailsTitle">جزئیات سرویس</div>
        <div class="detailsList">
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon iconName="User" :size="22" color="#34be73" type="bold" />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">نام مسافر:</div>
              <div class="contentValue">
                {{ SearchList?.nickname || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb stationName">
            <div class="thumbIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  d="M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z"
                />
                <path
                  fill-rule="evenodd"
                  d="M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">نام ایستگاه:</div>
              <div class="contentValue">
                {{ SearchList?.station_title || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="LocationTick"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">آدرس مبدا:</div>
              <div class="contentValue">
                {{ SearchList?.address || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="LocationCross"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">آدرس مقصد:</div>
              <div class="contentValue">
                {{ SearchList?.destination || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="TimerStart"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">زمان شروع سرویس:</div>
              <div class="contentValue">
                {{ SearchList?.start_time_fa || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="TimerPause"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">زمان پایان سرویس:</div>
              <div class="contentValue">
                {{ SearchList?.finish_time_fa || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="Money2"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">هزینه سرویس:</div>
              <div class="contentValue">
                {{ SearchList?.service_price || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon iconName="Box" :size="22" color="#34be73" type="bold" />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">حمل بار:</div>
              <div class="contentValue">
                {{ SearchList?.cargo_price || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="Timer"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">زمان سرویس:</div>
              <div class="contentValue">
                {{ SearchList?.noTrafficDuration || "-" }}
                <span v-if="SearchList?.noTrafficDuration">دقیقه</span>
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon iconName="Map1" :size="22" color="#34be73" type="bold" />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">کیلومتر طی شده:</div>
              <div class="contentValue">
                {{ SearchList?.distance || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="PauseCircle"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">دقیقه توقف:</div>
              <div class="contentValue">
                {{ SearchList?.stopDuration || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="DollarCircle"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">هزینه توقف:</div>
              <div class="contentValue">
                {{ SearchList?.stop_price || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="UsdCoin"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">هزینه کولر:</div>
              <div class="contentValue">
                {{ SearchList?.ac_price || "-" }}
              </div>
            </div>
          </div>
          <div class="detailsThumb">
            <div class="thumbIcon">
              <VsxIcon
                iconName="DocumentText"
                :size="22"
                color="#34be73"
                type="bold"
              />
            </div>
            <div class="thumbContent">
              <div class="contentTitle">توضیحات:</div>
              <div class="contentValue">
                {{ SearchList?.description || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import { mapGetters } from "vuex";
// import router from '../router'

import NeshanMap from "@neshan-maps-platform/vue3-openlayers";
import { fromLonLat } from "@neshan-maps-platform/ol/proj";
import Feature from "@neshan-maps-platform/ol/Feature";
import Point from "@neshan-maps-platform/ol/geom/Point";
import VectorSource from "@neshan-maps-platform/ol/source/Vector";
import VectorLayer from "@neshan-maps-platform/ol/layer/Vector";
import { Style, Icon } from "@neshan-maps-platform/ol/style";
import Iconmarker1 from "@/assets/img/marker1.png";
import Iconmarker2 from "@/assets/img/marker2.png";
import Iconmarker3 from "@/assets/img/marker3.png";

export default {
  components: {
    // PerfectScrollbar,
    NeshanMap,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      BtnSvue: 1,
      id: 0,
      // zoom: 17,
      userBox: "0",
      SearchList: [],
      marker1: null,
      marker2: null,
      marker3: null,
      map: null,
      dropArea: null,
      marker_add: null,
      time: "",
      style2: "border-bottom: 2px solid #68A1FF;",
      style1: "",
      isDarkMode: false,
      reloadKey: 0,
      list: [],
      step_load: 0,
      markericon: [],
    };
  },
  computed: {
    ...mapGetters(["auth_taxi", "taxi_c_set"]),
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    let self = this;
    self.markericon[0] = Iconmarker1;
    self.markericon[1] = Iconmarker2;
    self.markericon[2] = Iconmarker3;

    if (
      this.taxi_c_set.map_info.map_key != "" &&
      this.taxi_c_set.map_info.map_service != ""
    ) {
      this.NeshanMapLoad = true;
      this.service_api = this.taxi_c_set.map_info.map_service;
    }

    setInterval(() => {
      this.loadTheme();
    }, 100);
  },
  methods: {
    getmounted(map) {
      this.step_load += 1;
      this.scrollToTop();
      this.getInfo();
      // this.mapAction(this.$route.params.id)
      this.toTop();
      this.dropArea = document.getElementById("drop-area");

      setInterval(() => {
        const now = new Date();
        const options = { hour: "numeric", minute: "numeric" };
        this.time = now.toLocaleTimeString([], options);
      }, 1000);

      if (this.step_load >= 2)
        //بدلیل 2 بار لواد شدن نقشه برای این فانکشن محدودیت گذاشته شد
        this.initializeMap(map);
    },
    initializeMap(map) {
      let self = this;
      this.helperGet_taxi(
        "customer-service-info",
        "&uid=" + this.auth_taxi.uid + "&service_id=" + this.$route.params.id
      ).then((json) => {
        this.SearchList = json.data.data;
        const view = map.getView();
        view.animate({
          center: fromLonLat([
            self.SearchList.origin.lng,
            self.SearchList.destination_arr.lat,
          ]),
          zoom: 12,
          duration: 100,
        });
        this.list[0] = json.data.data.origin;
        this.list[1] = json.data.data.destination_arr;
        this.list[2] = json.data.data.second_destination_arr;

        this.mapAction(map);
      });
    },
    mapAction(map) {
      let self = this;
      this.marker_add = 0;

      if (this.marker_add === 0) {
        if (self.list.length > 0) {
          self.list.forEach((value, index) => {
            if (index < 3 && value.lat && value.lng) {
              const marker = new Feature({
                geometry: new Point(fromLonLat([value.lng, value.lat])),
              });

              const iconStyle = new Style({
                image: new Icon({
                  src: self.markericon[index],
                  scale: 0.8,
                }),
              });

              marker.setStyle(iconStyle);

              const vectorSource = new VectorSource({
                features: [marker],
              });

              const markerLayer = new VectorLayer({
                source: vectorSource,
              });

              map.addLayer(markerLayer);
            }
          });
          this.marker_add = 1;
        }
      }
    },
    loadTheme() {
      const savedTheme = localStorage.getItem("theme");

      if (this.savedTheme1 !== savedTheme) {
        this.savedTheme1 = savedTheme;

        if (savedTheme == "light") {
          this.isDarkMode = false;
        } else {
          this.isDarkMode = true;
        }

        this.reloadKey += 1;
      }
    },

    scrollToTop() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer; // بدون $el
        if (container) {
          container.scrollTop = 0; // به بالای صفحه بروید
        } else {
          console.warn("scrollContainer is not defined");
        }
      });
    },
    styleMenu(value) {
      this.BtnSvue = value;

      if (value === 1) {
        this.style1 = "";
        this.style2 = "border-bottom: 2px solid #68A1FF;";
      }
      if (value === 2) {
        this.style1 = "border-bottom: 2px solid #68A1FF;";
        this.style2 = "";
      }
    },
    toTop() {
      window.location.href = "#inspire";
    },
    getInfo() {
      this.userBox = this.auth_taxi;
    },
    navigate() {
      this.id = 0;
      this.map.removeLayer(this.marker1);
      this.map.removeLayer(this.marker2);
      this.map.removeLayer(this.marker3);
      // router.go(-2);
    },
  },
};
</script>

<style scoped>
.AllPwaMobileClass1 {
  display: grid;
  grid-template-columns: 45% 45% 10% !important;
  align-items: center !important;
}

.serviceDetails {
  position: relative;
  width: 100%;
  height: 100vh;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  .detailsClsoeBtn {
    width: 42px;
    height: 42px;
    background: #0851a0;
    box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.35) !important;
    border-radius: 10px;
    cursor: pointer;
    color: #fff;
    position: absolute;
    z-index: 2;
    top: 24px;
    left: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 28px;
      height: 28px;
      stroke-width: 2.5;
    }
  }

  .detialsMapWrapper {
    position: relative;
    height: calc(100% - 468px);

    .detialsMap {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      margin: auto;
      overflow: hidden;
      z-index: 1;

      &.map {
        :deep(.ol-viewport) {
          & > div {
            &:last-child {
              display: none !important;
            }
          }
        }
      }
    }
  }

  .detailsContent {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 482px;
    margin-top: -14px;
    background: #fff;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    box-shadow: 0 -8px 8px 0 rgba(0, 0, 0, 0.2);
    padding-top: 24px;
    direction: rtl;
    color: #000;

    .contentWrapper {
      height: 450px;

      .detailsTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.15rem;
        text-align: center;
        padding-bottom: 16px;
        box-shadow: 0 3px 4px rgba(0, 0, 0, 0.15);
      }

      .detailsList {
        width: 90%;
        height: 402px;
        margin-left: auto;
        margin-right: auto;
        padding-top: 8px;
        overflow-x: hidden;
        overflow-y: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .detailsThumb {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 8px;
          border-bottom: 1px solid #dedede;

          &.stationName {
            .thumbIcon {
              color: rgb(8, 81, 160);
              svg {
                width: 22px;
                height: 22px;
              }
            }
          }

          .thumbIcon {
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            background: rgba(8, 81, 160, 0.15);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }

          .thumbContent {
            flex-grow: 1;
            padding: 12px 8px;
            gap: 4px;

            .contentTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 0.9rem;
              flex-shrink: 0;
            }

            .contentValue {
              font-size: 0.8rem;
              color: #454545;
            }
          }
        }
      }
    }
  }
}
</style>
